export default __webpack_public_path__ + "static/media/7SG17.dc350563.jpg";